export default "__VITE_ASSET__Bf2DWYJi__"